import { Result } from "antd";

interface PagePlaceholderProps {
  /** 页面标题 */
  title: string;
}

/** 迁移动期占位页，后续替换为真实业务页面 */
export const PagePlaceholder = ({ title }: PagePlaceholderProps) => {
  return <Result status="info" title={title} subTitle="页面开发中" />;
};
